/**
 * Main client-side application entry point.
 *
 * This file is the entry point for esbuild bundling.
 * It detects the current page and initializes page-specific functionality.
 */

// Import web components (registers custom elements globally)
import "./web-components";

// Import page-specific modules
import { initLogin } from "./login";
import { initRegister } from "./register";
import { initAccount } from "./account";
import { initSetPassword } from "./set-password";
import { initGallery } from "./gallery";

// Detect current page and initialize
function init(): void {
  const path = window.location.pathname;

  if (path === "/" || path === "/login") {
    initLogin();
  } else if (path === "/register") {
    initRegister();
  } else if (path === "/account") {
    initAccount();
  } else if (path === "/set-password") {
    initSetPassword();
  } else if (path === "/web-components") {
    initGallery();
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
